import type { StageDef } from './data/maps';
import { stages } from './data/maps';

export const CUSTOM_STAGE_STORAGE_KEY = 'maru-marble-roulette-custom-stage';

export function cloneStage(stage: StageDef): StageDef {
  return JSON.parse(JSON.stringify(stage)) as StageDef;
}

export function loadCustomStageFromStorage(): StageDef | null {
  try {
    const raw = localStorage.getItem(CUSTOM_STAGE_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as StageDef;
    if (!parsed || typeof parsed.title !== 'string') return null;
    if (typeof parsed.goalY !== 'number' || typeof parsed.zoomY !== 'number') return null;
    if (!Array.isArray(parsed.entities)) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function saveCustomStageToStorage(stage: StageDef): void {
  localStorage.setItem(CUSTOM_STAGE_STORAGE_KEY, JSON.stringify(stage));
}

export function defaultWheelStage(): StageDef {
  return cloneStage(stages[0]!);
}
